import { getDownloadURL, listAll, ref } from 'firebase/storage';
import { storage } from '../firebase/app';

const handleDownloadFromGcs = async (
  userId: string,
  modelId: string,
  filename: string,
) => {
  return await new Promise((resolve, reject) => {
    getDownloadURL(
      ref(storage, `users/${userId}/models/${modelId}/${filename}`),
    )
      .then((url: any) => resolve(url))
      .catch((e) => reject(e));
  });
};

const handleDownloadVideoTourFromGcs = async (userId: string, pid: string) => {
  return await new Promise((resolve, reject) => {
    getDownloadURL(ref(storage, `users/${userId}/videoTours/${pid}/output.mp4`))
      .then((url: any) => resolve(url))
      .catch((e) => reject(e));
  });
};

const handleGetLBlobsGcs = async (storageRef: string) => {
  const items: any[] = [];
  // Create a reference under which you want to list
  const listRef = ref(storage, storageRef);

  return await new Promise((resolve, reject) => {
    listAll(listRef)
      .then((res) => {
        const { length } = res.items;
        res.items.forEach((item) => {
          getDownloadURL(item).then((url) => {
            const data = {
              name: item.name,
              src: url,
            };
            items.push(data);
            if (length === items.length) resolve(items);
          });
        });
      })
      .catch((error) => reject(error));
  });
};

export {
  handleDownloadFromGcs,
  handleDownloadVideoTourFromGcs,
  handleGetLBlobsGcs,
};
